module.exports = __webpack_public_path__ + "static/img/wap.1d15a3a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cn/来华/wap.svg
// module id = 05vo
// module chunks = 16